<template>
	<form @submit.prevent="saveAll()" method="post">
		<Form @set-input="setInput" />
		<fieldset class="dt-responsive table-responsive">
			<legend>ELECTRONIC MEDIA ADVERTISEMENTS:</legend>
			<table id="dt-live-dom" class="table table-bordered wrap">
				<thead>
					<tr>
						<!-- <th>S/NO</th> -->
						<th style="width: 25%">MEDIA HOUSE</th>
						<th style="width: 5%">MEDIA HOUSE/DESCRIPTION</th>
						<th>SLOT (S)</th>
						<th style="width: 5%">DURATION <br />IN DAYS</th>
						<th style="width: 25%">UNIT COST</th>
						<th style="width: 25%">TOTAL COST</th>
						<th>REMARKS</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(form, index) in forms" :key="form.id">
						<td>
							<a
								@click.prevent="deleteForm(form.id, index)"
								href="#"
								class="btn btn-danger btn-sm"
								><i class="feather icon-trash-2"></i>
							</a>
							{{ form.media_house }}
						</td>
						<td>{{ form.description }}</td>
						<td>{{ form.slots }}</td>
						<td>{{ form.duration }}</td>
						<td>{{ form.unit_cost }}</td>
						<td>{{ form.total_cost }}</td>
						<td>{{ form.remarks }}</td>
					</tr>
					<tr>
						<!-- <td>1</td> -->
						<td>
							<textarea
								v-model="form.media_house"
								class="form-control"
								type="text"
								id="media_house"
								name="media_house"
								rows="1"
								placeholder="Enter media name"
								required
							></textarea>
						</td>
						<td>
							<textarea
								v-model="form.description"
								class="form-control"
								type="text"
								id="description"
								name="description"
								rows="1"
								placeholder="Enter description"
							></textarea>
						</td>
						<td>
							<input
								@input="inputMustBeUnsignedInteger('slots')"
								@change="calculateTotalCost()"
								v-model="form.slots"
								class="form-control"
								type="text"
								id="slots"
								name="slots"
								required
							/>
						</td>
						<td>
							<input
								v-model="form.duration"
								@input="inputMustBeUnsignedInteger('duration')"
								class="form-control"
								type="text"
								id="duration"
								name="duration"
							/>
						</td>
						<td>
							<input
								@input="inputMustBeCurrency('unit_cost')"
								@change="calculateTotalCost()"
								v-model="form.unit_cost"
								class="form-control"
								type="text"
								id="unit_cost"
								name="unit_cost"
								required
							/>
						</td>
						<td>
							<input
								v-model="form.total_cost"
								class="form-control"
								type="text"
								id="total_cost"
								name="total_cost"
								readonly
								required
							/>
						</td>
						<td>
							<textarea
								v-model="form.remarks"
								class="form-control"
								type="text"
								id="remarks"
								name="remarks"
								rows="1"
								placeholder="Enter remarks"
							></textarea>
						</td>
					</tr>
				</tbody>
			</table>
		</fieldset>

		<div align="center" style="margin-bottom: 0; margin-top: 2rem">
			<LoadingButton class="btn btn-info">Save All</LoadingButton>
		</div>
	</form>
</template>
<script>
import { mustBeUnsignedInteger, mustBeCurrency } from "@/utils/input_filter.js";
import { EventBus } from "@/utils/event_bus.js";
import LoadingButton from "@/components/LoadingButton.vue";
import { mapActions } from "vuex";
import Form from "@/components/Form.vue";

export default {
	props: {
		candidate_name: {
			type: String,
			// required: true,
		},
		advert_type_id: {
			type: String,
			required: true,
		},
	},
	components: {
		Form,
		LoadingButton,
	},
	data() {
		return {
			forms: [],
			form: {
				media_house: "",
				description: "",
				slots: "",
				duration: "",
				unit_cost: "",
				total_cost: 0,
				remarks: "",

				party_id: "",
				state_code: "",
				elective_position_id: "",
				report_submission_id: "",
				lga_id: "",
				date_reported: "",
				constituency_id: "",
				advert_type_id: this.advert_type_id ?? "", // Electronic Media ID
				candidate_name: this.candidate_name ?? "",
			},
		};
	},
	methods: {
		...mapActions({
			addElectronicMediaForm: "form_ec16f/addElectronicMediaForm",
			deleteById: "form_ec16f/deleteById",
		}),

		async saveAll() {
			await this.addElectronicMediaForm(this.form).then((response) => {
				if (response) {
					this.forms.push(response);
					this.clearFormInputs();
				}
			});
		},

		clearFormInputs() {
			this.form.media_house = "";
			this.form.description = "";
			this.form.slots = "";
			this.form.duration = "";
			this.form.unit_cost = "";
			this.form.total_cost = 0;
			this.form.remarks = "";
		},

		calculateTotalCost() {
			if (this.form.slots === "") {
				this.form.slots = 1;
			}

			let total = parseInt(this.form.slots) * parseFloat(this.form.unit_cost);
			this.form.total_cost = isNaN(total) ? 0 : total;
		},

		inputMustBeUnsignedInteger(input_id) {
			return mustBeUnsignedInteger(input_id);
		},

		inputMustBeCurrency(input_id) {
			return mustBeCurrency(input_id);
		},

		async deleteForm(form_id, index) {
			if (!confirm("Are you sure you want to delete?")) {
				return;
			}

			this.deleteById({ id: form_id }).then((response) => {
				if (response === "success") {
					this.forms.splice(index, 1);
				}
			});
		},

		setInput(params) {
			this.form[params.name] = params.value;
		},
	},
	created() {
		EventBus.$on("set-params", this.setInput);
	},
};
</script>

<style scoped>
fieldset {
	background-color: #eeeeee;
}

legend {
	background-color: #29623c;
	color: white;
	padding: 5px 10px;
}
.btn-info {
	width: 200px;
	border-radius: 6px;
}
</style>
